const LS_SELECTED_DOMAIN_KEY = 'selectedDomain';
const CREATE_OFFERING_KEY = (domainId: string) =>
  `createOfferingDraft_${domainId}`;
const EDIT_OFFERING_KEY = (offeringId: string, domainId: string) =>
  `edit_${domainId}_${offeringId}`;

export { LS_SELECTED_DOMAIN_KEY, CREATE_OFFERING_KEY, EDIT_OFFERING_KEY };
